export default __webpack_public_path__ + "static/media/Fly.01a99ec9.png";